<style>
	.copy-btn{
		margin-left: 10px; 
		font-size: 16px;
		cursor: pointer
	}
	.proIcon{
		margin-left: 20px;
		padding-top: 35px;
	}
	.proIcon i{
		font-size: 18px;
		margin-bottom: 20px;
		display: block;
		cursor: pointer;
	}
</style>
<template>
	<div class="contentbox">
		<div>
			<div class="top-search">
				<el-form :inline="true" :model="formInline" ref="formInline" size="small" class="demo-form-inline">
					<el-form-item label="链接名称" prop="title">
						<el-input v-model="formInline.title" placeholder="请输入链接名称" clearable @keyup.enter.native="search" @clear="search" style="width: 200px;"></el-input>
					</el-form-item>
					<el-form-item label="描述" prop="describe">
						<el-input v-model="formInline.describe" placeholder="请输入描述" clearable @keyup.enter.native="search" @clear="search" style="width: 200px;"></el-input>
					</el-form-item>
					<el-form-item label="投放链接ID" prop="id">
						<el-input v-model="formInline.id" placeholder="请输入投放链接ID" clearable @keyup.enter.native="search" @clear="search" style="width: 200px;"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
					</el-form-item>
					<el-form-item>
						<el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
					</el-form-item>
					<br />
					<el-form-item>
						<el-button type="success" v-has="'agentProLink:add'" icon="el-icon-circle-plus-outline" @click="addData">添加</el-button>
						<el-button type="success" icon="el-icon-document-copy" @click="getMonitoringLink">复制检测链接</el-button>
						<!--<span style="margin-left: 16px"><i class="el-icon-refresh-right" style="color: #409eff;margin-right: 5px;"></i>{{countdown}}秒后数据刷新</span>-->
					</el-form-item>
				</el-form>
			</div>
			<div class="tableTh" v-height>
				<el-table :data="tableData.result" border stripe style="width: 100%" height="100%" class="tableStyle" v-loading="loading">
					<el-table-column prop='' label="序号" width="55" fixed>
						<template slot-scope="scope">
							<span>{{ (tableData.pageNo - 1) * tableData.pageSize + scope.$index + 1 }}</span>
						</template>
					</el-table-column>
					<el-table-column label="链接名称/描述" width="150" fixed>
						<template slot-scope="scope">
							<div class="td-info">
								<p>链接名称：{{ scope.row.title }}</p>
								<p>描述：{{ scope.row.linkDescribe }}</p>
								<p>投放平台：{{ scope.row.platform || '微博' }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="投放链接ID" prop="id" width="140" fixed>
					</el-table-column>
					<el-table-column label="推广链接" width="400">
						<template slot-scope="scope">
							<div class="td-info">
								<span>{{ scope.row.link }}</span>
								<i class="el-icon-document-copy succes-text copy-btn" @click="handleCopy(scope.row.link)"></i>
								<!--<el-button type="success" size="mini" @click="handleCopy(scope.row.link)" style="margin-left: 10px;">复制</el-button>-->
								<!--<p>小程序path：{{ scope.row.appPath }}</p>-->
							</div>
						</template>
					</el-table-column>
					<el-table-column label="绑定小程序" width="180">
						<template slot-scope="scope">
							<div class="td-info">
								<p>appid：{{ scope.row.appid }}</p>
								<p>小程序名称：{{ scope.row.appidName }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="书籍信息" width="200">
						<template slot-scope="scope">
							<div class="td-info">
								<p>书籍名：{{ scope.row.bookName }}</p>
								<!--<p>别名：{{ scope.row.aliasName }}</p>-->
								<p>跳转章节：{{ scope.row.chapterNumber }}</p>
								<p>免费章节数：{{ scope.row.userFreeChapter }}</p>
								<!--<p>每集金币数：{{ scope.row.epPrice }}</p>-->
								<!--<p>解锁模式：-->
								<!--<span v-if="scope.row.priceFlag == 0">纯付费解锁</span>-->
								<!--&lt;!&ndash; <span v-if="scope.row.priceFlag == 1">纯整剧付费</span> &ndash;&gt;-->
								<!--<span v-if="scope.row.priceFlag == 2">纯广告解锁</span>-->
								<!--<span v-if="scope.row.priceFlag == 3">单集付费+广告解锁</span>-->
								<!--</p>-->
							</div>
						</template>
					</el-table-column>
					<el-table-column label="方案配置" width="120">
						<template slot-scope="scope">
							<div class="td-info">
								<!--<p v-if="scope.row.posterName">广告解锁方案：{{ scope.row.posterName }}</p>-->
								<!--<p v-if="scope.row.rechargeName">充值方案：{{ scope.row.rechargeName }}</p>-->
								<p>{{ scope.row.postbackName }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="用户信息" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>总用户：{{ scope.row.totalUserNumber || 0 }}</p>
								<p>当日新用户：{{ scope.row.todayUserNumber || 0 }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="充值信息" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>总充值金额：{{ scope.row.totalMoney || 0 }}</p>
								<p>当日充值金额：{{ scope.row.todayMoney || 0 }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="创建时间" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{ scope.row.addTime }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="350" fixed="right">
						<template slot-scope="scope" class="ddd">
							<el-button type="defult" icon="el-icon-warning-outline" size="mini"
							@click="handleLook(scope.row.id)">详情</el-button>
							<el-button type="primary" v-has="'agentProLink:configuration'" icon="el-icon-edit" size="mini" @click="handleEdit(scope.row.id)">编辑</el-button>
							<el-popover width="160" :ref="scope.row.id" style="margin-left: 10px;">
								<p class="popover-con del">
									<i class="el-icon-question warnning-text"></i>确定删除吗？
								</p>
								<div style="text-align: right;">
									<el-button size="mini" @click="$refs[scope.row.id].doClose()">取消</el-button>
									<el-button type="primary" size="mini" @click="handleDelete(scope.row.id)">确定</el-button>
								</div>
								<el-button slot="reference" type="danger" icon="el-icon-delete" size="mini">删除</el-button>
							</el-popover>
							<el-dropdown trigger="click" v-has="'agentProLink:more'" style="margin-left: 10px;">
								<el-button type="success" size="mini">
									更多<i class="el-icon-arrow-down el-icon--right"></i>
								</el-button>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item command="addVid" @click.native="handleGoReturnOrder(scope.row.id)">跳转补回传</el-dropdown-item>
									<!--<el-dropdown-item @click.native="handleCopyEdit(scope.row.id)">复制</el-dropdown-item>-->
									<el-dropdown-item @click.native="handleCustomizePost(scope.row.id)">自定义广告计划回传</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</template>
					</el-table-column>
				</el-table>
				<div class="foot-table" style="text-align:center;">
					<el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange" :page-sizes="[20, 50, 100, 200, 500]" :page-size="tableData.pageSize" background :current-page="currentPage" layout="sizes, prev, pager, next, jumper, ->, total" :total="tableData.totalNum">
					</el-pagination>
				</div>
			</div>
		</div>
		<!--详情-->
		<el-dialog title="详情" :visible.sync="dialogInfoVisible" center width="800px">
			<table class="el-table el-table--border el-table--enable-row-hover mytable" cellspacing="0" cellpadding="0">
				<tbody>
				<tr>
					<td width="200">链接名称/名称</td>
					<td>
						<div class="td-info">
							<p>链接名称：{{ rowForm.title }}</p>
							<p>描述：{{ rowForm.linkDescribe }}</p>
                            <p>投放平台：{{ rowForm.platform || '微博' }}</p>
						</div>
					</td>
				</tr>
				<tr>
					<td>投放链接ID</td>
					<td>
						{{ rowForm.id }}
					</td>
				</tr>
				<tr>
					<td>推广链接/小程序路径</td>
					<td>
						<p>投放路径：{{ rowForm.link }}</p>
						<p>小程序path：{{ rowForm.appPath }}</p>
					</td>
				</tr>
				<tr>
					<td>剧集信息</td>
					<td>
						<p>书籍名：{{ rowForm.bookName }}</p>
						<!--<p>别名：{{ rowForm.aliasName }}</p>-->
						<p>跳转章节：{{ rowForm.chapterNumber }}</p>
						<p>免费章节数：{{ rowForm.userFreeChapter }}</p>
						<!--<p>每集金币数：{{ rowForm.epPrice }}</p>-->
						<!--<p>解锁模式：-->
							<!--<span v-if="ruleForm.priceFlag == 0">纯付费解锁</span>-->
							<!--&lt;!&ndash; <span v-if="ruleForm.priceFlag == 1">纯整剧付费</span> &ndash;&gt;-->
							<!--<span v-if="ruleForm.priceFlag == 2">纯广告解锁</span>-->
							<!--<span v-if="ruleForm.priceFlag == 3">单集付费+广告解锁</span>-->
						<!--</p>-->
					</td>
				</tr>
				<tr>
					<td>方案配置</td>
					<td>
						<!--<p v-if="rowForm.posterName">广告解锁方案：{{ rowForm.posterName }}</p>-->
						<p v-if="rowForm.rechargeName">充值方案：{{ rowForm.rechargeName }}</p>
						<p>回传方案：{{ rowForm.postbackName }}</p>
					</td>
				</tr>
				<tr>
					<td>总充值金额</td>
					<td>
						<p>{{ rowForm.totalMoney || 0 }}</p>
					</td>
				</tr>
				<tr>
					<td>当日充值金额</td>
					<td>
						<p>{{ rowForm.todayMoney || 0 }}</p>
					</td>
				</tr>
				</tbody>
			</table>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogInfoVisible = false">确 定</el-button>
			</div>
		</el-dialog>
		<!--修改弹框-->
		<el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" :close-on-click-modal="false" width="700px">
			<el-form :rules="rules" ref="ruleForm" :model="ruleForm" label-width="150px" class="input350" size="small" style="max-height: 550px;overflow: auto; padding-right: 20px;">
				<el-form-item label="链接名称：" prop="title">
					<el-input v-model="ruleForm.title" placeholder="请输入广告ID"></el-input>
				</el-form-item>
				<el-form-item label="描述：" prop="linkDescribe">
					<el-input v-model="ruleForm.linkDescribe" placeholder="请输入描述"></el-input>
				</el-form-item>
				<el-form-item label="选择书籍：" prop="bookId">
					<el-tag closable @close="handleCloseTagBook" v-if="ruleForm.bookName" style="margin-right: 10px;">{{ ruleForm.bookName }}</el-tag>
					<el-button type="primary" size="small" :disabled="ruleForm.change == 'upd' ? true : false" @click="isShowDialogBook = true">选择</el-button>
					<el-input v-model="ruleForm.bookId" style="display: none;"></el-input>
				</el-form-item>
				<el-form-item label="书籍解锁模式：" prop="priceFlag">
					<el-select v-model="ruleForm.priceFlag" filterable clearable placeholder="请选择书籍解锁模式">
						<el-option
								v-for="item in priceFlagOptions"
								:key="item.value"
								:label="item.label"
								:value="item.value"
						>
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="跳转章节数：" prop="chapterNumber">
					<el-input type="number" v-model="ruleForm.chapterNumber" placeholder="请输入总章节数"></el-input>
				</el-form-item>
				<!--<el-form-item label="免费章数：" prop="userFreeChapter">-->
					<!--<el-input type="number" v-model="ruleForm.userFreeChapter" placeholder="请输入免费集数"></el-input>-->
				<!--</el-form-item>-->
				<el-form-item label="充值方案：" prop="rechargeId">
					<el-tag closable @close="handleCloseTagRecharge" v-if="ruleForm.rechargeName"
							style="margin-right: 10px;">{{ ruleForm.rechargeName }}</el-tag>
					<el-button type="primary" size="small" @click="changeRecharge">选择</el-button>
					<el-input v-model="ruleForm.rechargeId" style="display: none;"></el-input>
				</el-form-item>
				<el-form-item label="选择回传方案：" prop="postbackId">
					<el-tag closable @close="handleCloseTagReturn" v-if="ruleForm.postbackName"
							style="margin-right: 10px;">{{ ruleForm.postbackName }}</el-tag>
					<el-button type="primary" size="small" @click="isShowDialogReturn = true">选择</el-button>
					<el-input v-model="ruleForm.postbackId" style="display: none;"></el-input>
				</el-form-item>
                <el-form-item label="选择投放平台：" prop="platform">
					<el-select v-model="ruleForm.platform" filterable clearable placeholder="请选择投放平台">
						<el-option
								v-for="item in platformOptions"
								:key="item.value"
								:label="item.label"
								:value="item.value"
						>
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="绑定小程序：">
					<el-input v-model="ruleForm.appidName" disabled="disabled"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" v-debounce:500="editDialogSureBtn">确 定</el-button>
			</div>
		</el-dialog>
		<!--更多计划弹框-->
		<el-dialog title="自定义广告计划回传" :visible.sync="dialogFormVisibleMore" :close-on-click-modal="false" width="700px">
			<el-form :rules="rulesMore" ref="ruleFormMore" :model="ruleFormMore" label-width="120px" class="input350" size="small" style="max-height: 550px;overflow: auto; padding-right: 20px; ">
				<el-form-item v-if="ruleFormMore.postList.length > 0">
					<div v-for="(item, index) in ruleFormMore.postList" :key="index" style="margin-left: -100px; margin-top: 25px; position: relative; display: flex; flex-direction: row">
						<div style="width: 500px; padding: 15px; border: 1px dashed #ddd; border-radius: 10px;">
							<el-form-item label="广告计划ID：" :prop="'postList.' + index + '.adId'" :rules="rulesMore.adId" :key="'postList.' + index + '.adId'">
								<el-input v-model="item.adId" placeholder="请输入广告计划ID" :disabled="item.adIdSaveFlag"></el-input>
							</el-form-item>
							<el-form-item label="选择回传方案：" :prop="'postList.' + index + '.postbackId'" :rules="rulesMore.postbackId" :key="'postList.' + index + '.postbackId'">
								<template v-if="item.adIdSaveFlag">
									<el-tag @close="handleCloseTagReturnMore(index)" v-if="item.postbackName" :disabled="item.adIdSaveFlag" style="margin-right: 10px;">{{ item.postbackName }}</el-tag>
								</template>
								<template v-else>
									<el-tag closable @close="handleCloseTagReturnMore(index)" v-if="item.postbackName" :disabled="item.adIdSaveFlag" style="margin-right: 10px;">{{ item.postbackName }}</el-tag>
								</template>
								<!--<el-tag closable @close="handleCloseTagReturnMore(index)" v-if="item.postbackName" :disabled="item.adIdSaveFlag" style="margin-right: 10px;">{{ item.postbackName }}</el-tag>-->
								<el-button type="primary" size="small" @click="changePost(index)" :disabled="item.adIdSaveFlag">选择</el-button>
								<el-input v-model="item.postbackId" style="display: none;"></el-input>
							</el-form-item>
						</div>
						<div class="proIcon">
							<!--</template>-->
							<i class="el-icon-circle-plus-outline" v-if="index == 0" @click="addPostId"></i>
							<i class="el-icon-delete" @click="delPostId(index)"></i>
						</div>
					</div>
				</el-form-item>
				<el-form-item v-else>
					<div style="margin-left: -100px; margin-top: 25px; position: relative; display: flex; flex-direction: row">
						<div style="width: 500px; padding: 15px; border: 1px dashed #ddd; border-radius: 10px;">
							<p style="padding: 20px 0; text-align: center; font-size: 16px;">已删除全部自定义广告计划回传方案</p>
						</div>
						<div class="proIcon">
							<!--</template>-->
							<i class="el-icon-circle-plus-outline" @click="addPostId"></i>
						</div>
					</div>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisibleMore = false">取 消</el-button>
				<el-button type="primary" v-debounce:500="editDialogSureBtnPost">确 定</el-button>
			</div>
		</el-dialog>
		<book-table :visible.sync="isShowDialogBook" :appId="ruleForm.appid" :selectBook="selectBook" @bookSure="bookSure" @cancelDialogBook="cancelDialogBook"></book-table>
		<return-table-wb :visible.sync="isShowDialogReturn" :bookId="ruleForm.bookId" :postbackId="ruleForm.postbackId" :posterId="ruleForm.posterId" :rechargeId="ruleForm.rechargeId" :selectReturn="selectReturn" @returnSure="returnSure" @cancelDialogReturn="cancelDialogReturn"></return-table-wb>
		<recharge-table-plan :visible.sync="isShowRechargeTable" :rechargeId="ruleForm.rechargeId" :appId="ruleForm.appid" :selectRecharge="selectRecharge" @rechargeSure="rechargeSure" @cancelDialogRecharge="cancelDialogRecharge"></recharge-table-plan>
		<agent-pop :visible.sync="isShowDialogAgent"></agent-pop>
	</div>
</template>
<script>
    import AgentPop from '@/components/AgentPop'
    import BookTable from '@/components/wbdp/BookTable';
    import ReturnTableWb from '@/components/wb/ReturnTable';
    import RechargeTablePlan from '@/components/wbdp/RechargeTablePlan'
    import { list, add, details, del, monitoringLink, addPost, detailsPost, allAdId} from "@/api/wb/agentmenu/link";
    var editAdIdArr = [] // 编辑前的广告ID
	var allAdIdArr = [] // 总的广告ID
    var otherAdIdArr = [] // 出去编辑框的其他广告ID
    export default {
        components: {
            AgentPop,
            BookTable,
            ReturnTableWb,
            RechargeTablePlan
        },
        data() {
            var validateNum = (rule, value, callback) => {
                if (!(/(^[1-9]\d*$)/.test(value))) {
                    return callback(new Error('数字应为正整数'));
                } else {
                    callback();
                }
            };
            return {
                loading:false,
                formInline: {
                    id: '',
                    describe: '',
                    title: ''
                },
                tableData: {
                    pageSize: 20,
                    pageNo: 1,
                    totalPage: 1,
                    totalNum: 1,
                    result: []
                },
                currentPage: 1,
                dialogInfoVisible: false, // 详情弹框
                dialogTitle: '添加',
                dialogFormVisible: false, // 编辑弹框
                rowForm: {},
                unlockPlan:1,//充值方案
                ruleForm: {
                    agentId: '',
                    appid:  localStorage.getItem('appId'),
                    appidName: JSON.parse(localStorage.getItem('accountInfo')).bangdingAppName,
                    bookId: '',
                    bookName: '',
					change: 'add',
                    chapterNumber: 1,
                    id: '',
                    linkDescribe: '',
					postType: 2,
                    postbackId: '',
					postbackName: '',
					priceFlag: 0,
					rechargeId: '',
					rechargeName: '',
                    title: '',
                    platform:'wb'
                },
                rules: {
                    bookId: [
                        { required: true, message: '请选择书籍', trigger: 'change' }
                    ],
                    epNumber: [
                        { required: true, message: '请输入跳转集数', trigger: 'blur' },
                        { validator: validateNum, trigger: 'blur' }
                    ],
                    postbackId: [
                        { required: true, message: '请选择回传方案', trigger: 'change' }
                    ],
                    rechargeId: [
                        { required: true, message: '请选择充值方案', trigger: 'change' }
                    ],
                    agentName: [
                        { required: true, message: '请输入代理商', trigger: 'blur' }
                    ],
                    // priceFlag:[
                    // 	{ required: true, message: '请选择书籍解锁模式', trigger: 'change' }
                    // ],
                    // userFreeEp:[
                    // 	{ required: true, message: '请输入免费集数', trigger: 'change' }
                    // ],
                    // epPrice:[
                    // 	{ required: true, message: '请输入每集金币数', trigger: 'change' }
                    // ]
                },
                isShowDialogBook: false, // 书籍弹框
                selectBook: {},
                // isShowDialogAdUnlock: false, // 广告弹框
                // selectAdUnlock: {},
                isShowDialogReturn: false, // 回传弹框
                selectReturn: {},
                selectRecharge: {},
                isShowDialogAgent: true,
                isShowRechargeTable: false,
                countdown:60,//倒计时
                Timer: null, // 定时器
                priceFlagOptions: [
                    {
                        value: 0,
                        label: '纯付费解锁'
                    },
                    // {
                    //     value: 1,
                    //     label: '整本付费',
                    //     disabled: true
                    // },
                    // {
                    //     value: 2,
                    //     label: '纯广告解锁'
                    // },
                    // {
                    //     value: 3,
                    //     label: '付费+广告解锁'
                    // }
                ],
                tfIdEdit: '',
                dialogFormVisibleMore: false,
                ruleFormMore: {
                    postList: [
						{
                            adId: '',
                            adIdSaveFlag: false,
                            tfId: null,
                            postbackId: null,
                            postbackName: ''
						}
					]
                },
                rulesMore:{
                    adId: [
                        { required: true, message: '请输入广告计划ID', trigger: 'change' }
                    ],
                    postbackId: [
                        { required: true, message: '请选择回传方案', trigger: 'change' }
                    ],
				},
				dialogStatus: 1,
                editPostIndex: null,
                platformOptions: [
                    {
                        value: 'wb',
                        label: '微博'
                    },
                    {
                        value: 'dy',
                        label: '抖音'
                    },
                ],
            }
        },
        computed: {},
        watch: {
        },
        created() {
            if (JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId) {
                this.isShowDialogAgent = false
            } else {
                this.isShowDialogAgent = true
            }
        },
        mounted() {
            this.loading = true
            this.getTableData()
            // this.startTimer();
        },
        beforeDestroy(){
            clearInterval(this.Timer); // 清除定时器
        },
        methods: {
            //60s倒计时
            startTimer() {
                this.Timer = setInterval(() => {
                    if (this.countdown > 0) {
                        this.countdown--;
                    } else {
                        clearInterval(this.Timer);
                        this.loading = true
                        this.getTableData()
                        this.countdown = 60;
                        this.startTimer(); // 重新开始倒计时
                    }
                }, 1000);
            },
            // 确定剧
            bookSure(data) {
                console.log(data,"dadasd")
                this.ruleForm.bookName = data.bookName
                this.ruleForm.userFreeChapter = data.userFreeChapter
                // this.ruleForm.aliasName = data.BooklistVo.aliasName
                // this.ruleForm.strategyId = data.id
                this.ruleForm.bookId = data.bookId
                this.selectBook = data
                // this.ruleForm.priceFlag = data.priceFlag
                // this.ruleForm.epPrice = data.epPrice
                // this.ruleForm.userFreeEp = data.userFreeEp
            },
            // 删除所选剧
            handleCloseTagBook(tag) {
                console.log(tag)
                this.ruleForm.bookName = ''
                // this.ruleForm.aliasName = ''
                // this.ruleForm.strategyId = ''
                this.ruleForm.bookId = ''
                this.selectBook = {}
                // this.priceFlag = ''
            },
            // 关闭选剧弹窗
            cancelDialogBook(data) {
                console.log('cancel')
                this.isShowDialogBook = data
            },
            //选择充值方案
            changeRecharge() {
                if (!this.ruleForm.bookId) {
                    this.$message.error('请先选择书籍');
                } else {
                    this.isShowRechargeTable = true
                }
            },
            //确定选择充值方案
            rechargeSure(data) {
                this.ruleForm.rechargeName = data.planName
                this.ruleForm.rechargeId = data.id
                this.selectRecharge = data
                // this.ruleForm.posterName = ''
                // this.ruleForm.posterId = ''
                // this.selectAdUnlock = {}
            },
            // 删除所选充值方案
            handleCloseTagRecharge(tag) {
                console.log(tag)
                this.ruleForm.rechargeName = ''
                this.ruleForm.rechargeId = ''
                this.selectRecharge = {}
            },
            // 关闭充值方案弹窗
            cancelDialogRecharge(data) {
                console.log('cancel')
                this.isShowRechargeTable = data
            },
            // 确定回传方案
            returnSure(data) {
                if (this.dialogStatus == 1) {
                    this.ruleForm.postbackName = data.strategyName
                    this.ruleForm.postbackId = data.id
                    this.selectReturn = data   
				} else {
                    this.ruleFormMore.postList[this.editPostIndex].postbackName = data.strategyName
                    this.ruleFormMore.postList[this.editPostIndex].postbackId = data.id
                    this.selectReturn = data
                }
            },
            // 删除所选回传方案
            handleCloseTagReturn(tag) {
                console.log(tag)
                this.ruleForm.postbackName = ''
                this.ruleForm.postbackId = null
                this.selectReturn = {}
            },
            // 删除所选回传方案
            handleCloseTagReturnMore(index) {
                this.ruleFormMore.postList[index].adId= ''
                this.ruleFormMore.postList[index].postbackId = null
                this.ruleFormMore.postList[index].postbackName = ''
                this.selectReturn = {}
            },
            // 关闭回传方案弹窗
            cancelDialogReturn(data) {
                console.log('cancel')
                this.isShowDialogReturn = data
            },
            // changeUnlockPlan() {
            // 	if (!this.ruleForm.bookName) {
            // 		this.$message.error('请先选择书籍');
            // 	} else if (this.unlockPlan == 1) {
            // 		this.isShowDialogAdUnlock = true
            // 	} else {
            // 		this.isShowRechargeTable = true
            // 	}
            // },
            // 关闭广告方案弹窗
            // cancelDialogAdUnlock(data) {
            // 	console.log('cancel')
            // 	this.isShowDialogAdUnlock = data
            // },
            // 确定广告方案
            // adUnlockSure(data) {
            // 	this.ruleForm.posterName = data.programme
            // 	this.ruleForm.posterId = data.id
            // 	this.selectAdUnlock = data
            // 	this.ruleForm.rechargeName = ''
            // 	this.ruleForm.rechargeId = ''
            // 	this.selectRecharge = {}
            // },
            // // 删除所选广告方案
            // handleCloseTagAdUnlock(tag) {
            // 	console.log(tag)
            // 	this.ruleForm.posterName = ''
            // 	this.ruleForm.posterId = ''
            // 	this.selectAdUnlock = {}
            // 	this.ruleForm.rechargeName = ''
            // 	this.ruleForm.rechargeId = ''
            // 	this.selectRecharge = {}
            // },
            search() {
                this.loading = true
                this.currentPage = 1
                this.getTableData()
            },
            resetQuery() {
                this.loading = true
                this.$refs['formInline'].resetFields()
                this.getTableData()
            },
            // 添加表格
            addData() {
                if (this.$refs['ruleForm'] !== undefined) {
                    this.$refs['ruleForm'].resetFields()
                }
                this.dialogStatus = 1
                this.dialogTitle = '添加'
                this.ruleForm = {
                    agentId: '',
                    appid:  localStorage.getItem('appId'),
                    appidName: JSON.parse(localStorage.getItem('accountInfo')).bangdingAppName,
                    bookId: '',
                    bookName: '',
                    change: 'add',
                    chapterNumber: 1,
                    id: '',
                    linkDescribe: '',
                    postType: 2,
                    postbackId: '',
                    postbackName: '',
                    priceFlag: 0,
                    rechargeId: '',
                    rechargeName: '',
                    title: '',
                    platform: 'wb',
                }
                this.selectBook = {}
                this.dialogFormVisible = true
            },
            handleLook(id) {
                this.dialogInfoVisible = true
                this.getDetails(id, 'look')
            },
            // 删除
            handleDelete(id) {
                console.log(id)
                del({
                    id: id
                }).then(response => {
                    if (response.data.head.flag === 0) {
                        if (this.tableData.result.length === 1 && this.currentPage > 1) {
                            this.currentPage = this.currentPage - 1
                        }
                        this.$refs[id].doClose()
                        this.getTableData()
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                    } else {
                        this.$message.error(response.data.head.desc);
                    }
                })
            },
            // 编辑
            handleEdit(id) {
                if (this.$refs['ruleForm'] !== undefined) {
                    this.$refs['ruleForm'].resetFields()
                }
                this.dialogStatus = 1
                this.dialogTitle = '编辑'
                this.getDetails(id, 'edit')
                this.dialogFormVisible = true
            },
            // 获取详情
            getDetails(id, text) {
                details({
                    id: id,
                }).then(response => {
                    if (response.data.head.flag === 0) {
                        this.rowForm = response.data.content
                        if (text == 'edit') {
                            this.ruleForm = response.data.content
                            this.ruleForm.change = 'upd'
                            // if(this.ruleForm.rechargeId){
                            //     this.unlockPlan = 2
                            // }else{
                            //     this.unlockPlan = 1
                            // }
                        } else if (text == 'copy') {
                            this.ruleForm = {
                                agentId: '',
                                appid:  localStorage.getItem('appId'),
                                appidName: JSON.parse(localStorage.getItem('accountInfo')).bangdingAppName,
                                bookId: response.data.content.bookId,
                                bookName: response.data.content.bookName,
                                change: 'add',
                                chapterNumber: response.data.content.chapterNumber,
                                id: '',
                                linkDescribe: response.data.content.linkDescribe,
                                postType: response.data.content.postType,
                                postbackId: response.data.content.postbackId,
                                postbackName: response.data.content.postbackName,
                                priceFlag: response.data.content.priceFlag,
                                rechargeId: response.data.content.rechargeId,
                                rechargeName: response.data.content.rechargeName,
                                title: response.data.content.chapterNumber,
                                platform: response.data.content.platform || 'wb',
							}
						}
                    } else {
                        this.$message.error(response.data.head.desc);
                    }
                })
            },
            handleCopyEdit(id) {
                this.dialogTitle = '新增'
                this.getDetails(id, 'copy')
                this.dialogFormVisible = true
			},
            // 弹框确定
            editDialogSureBtn() {
                console.log(this.ruleForm)
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        console.log(this.ruleForm.change)
                        this.saveTableData()
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            // 保存编辑信息
            saveTableData() {
                add(this.ruleForm).then(response => {
                    if (response.data.head.flag === 0) {
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                        this.getTableData()
                        this.dialogFormVisible = false
                    } else {
                        this.$message.error(response.data.head.desc);
                    }
                })
            },
			// 添加自定义广告
            handleCustomizePost(id) {
                this.dialogStatus = 2
                this.tfIdEdit = id
                this.dialogTitle = '添加自定义广告'
				this.getDetailsPost(id)
            },
			addPostId () {
                this.ruleFormMore.postList.push({
                    tfId: this.tfIdEdit,
                    adId: '',
					adIdSaveFlag: false,
                    postbackId: null,
                    postbackName: ''
				})
			},
            delPostId(index) {
                this.ruleFormMore.postList.splice(index,1)
			},
			changePost(index) {
                this.isShowDialogReturn = true
				this.editPostIndex = index
			},
			// 一个数组内是否重复
            hasDuplicate(arr) {
				return new Set(arr).size !== arr.length;
			},
			// 两个数组中是否有重复
            hasDuplicates(arr1, arr2) {
				let set = new Set([...arr1, ...arr2]); 
				return set.size !== (arr1.length + arr2.length);
			},
            editDialogSureBtnPost () {
                this.$refs['ruleFormMore'].validate((valid) => {
                    if (valid) {
                        let adIdArr = this.ruleFormMore.postList.map(item => item.adId) // 编辑后的广告ID数组
						console.log('adIdArr', adIdArr)
						if (this.hasDuplicate(adIdArr)) { // 一个推广链接下的广告ID不能重复
                            this.$message.error('广告计划Id不能重复')
						} else if (this.hasDuplicates(adIdArr, otherAdIdArr)) {
                            this.$message.error('广告计划Id已存在')
						} else {
                            this.saveDataPost()
                        }
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
			},
            getDetailsPost(id) {
                detailsPost({
                    tfId: id,
                }).then(response => {
                    console.log(response)
                    if (response.data.content.length > 0) {
                        this.ruleFormMore.postList = response.data.content
                        this.ruleFormMore.postList.forEach((item) => {
                            item.adIdSaveFlag =  true
						})
						console.log(this.ruleFormMore)
                        editAdIdArr = response.data.content.map(item => item.adId)
						console.log(editAdIdArr)
						otherAdIdArr = allAdIdArr.filter(item => !editAdIdArr.includes(item));
                        console.log('otherAdIdArr' ,otherAdIdArr)
					} else {
                        this.ruleFormMore.postList = [
                            {
                                adId: '',
                                adIdSaveFlag: false,
                                tfId: this.tfIdEdit,
                                postbackId: null,
                                postbackName: ''
                            }
						]
                        // this.$refs['ruleFormMore'].resetFields()
                        if (this.$refs['ruleFormMore'] !== undefined) {
                            this.$refs['ruleFormMore'].clearValidate()
                        }
                        console.log('ruleFormMore', this.ruleFormMore)
					}
                    this.dialogFormVisibleMore = true
                })
            },
            saveDataPost () {
                console.log(this.ruleFormMore)
                let postListArr = this.ruleFormMore.postList.map(person => ({
                    tfId: person.tfId,
                    adId: person.adId.replace(/\s+/g, ''),
                    postbackId: person.postbackId,
                    postbackName: person.postbackName
                }));
                console.log(postListArr)
                addPost({tfId: this.tfIdEdit}, postListArr).then((response) => {
                    console.log(response)
                    if (response.data.head.flag === 0) {
                        // console.log(response.data.content)
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                        this.dialogFormVisibleMore = false
                        this.getTableData()
                    } else {
                        this.$message.error(response.data.head.desc)
                    }
                })
			},
			getAllAdId() {
                allAdId().then(response => {
                    if (response.data.head.flag === 0) {
                        allAdIdArr = response.data.content
						console.log(allAdIdArr)
                    } else {
                        this.$message.error(response.data.head.desc)
                    }
                }).catch((error) => {
                    this.loading = false
                    console.log("Error sending data:", error);
                });
			},
            // 获取列表
            getTableData() {
                let json2 = {
                    pageNo: this.currentPage,
                    pageSize: this.tableData.pageSize
                };
                let json1 = this.formInline;
                let paramJson = { ...json1, ...json2 };
                list(paramJson).then(response => {
                    if (response.data.head.flag === 0) {
                        this.loading = false
                        this.tableData = response.data.content
						this.getAllAdId()
                    } else {
                        this.$message.error(response.data.head.desc)
                    }
                }).catch((error) => {
                    this.loading = false
                    console.log("Error sending data:", error);
                });
            },
            handleCurrentChange(value) {
                this.loading = true
                this.currentPage = value
                this.getTableData()
            },
            handleSizeChange(val) {
                this.loading = true
                this.tableData.pageSize = val
                this.currentPage = 1
                this.getTableData()
            },
            // 一键填充id
            handleGoReturnOrder(id) {
                console.log(id)
                this.$router.push({ path: '/wbdp-ad-add-miss-return-list', query: { id: id } })
            },
            //暂停/开启数据更新
            // DataUpdates(row){
            // 	const info = {
            // 		disable:row.disable == 1?0:1,
            // 		infoId:row.id
            // 	}
            // 	disable(info).then(response => {
            // 		if (response.data.head.flag === 0) {
            // 			this.loading = true
            // 			this.getTableData()
            // 		} else {
            // 			this.$message.error(response.data.head.desc)
            // 		}
            // 	});
            //	
            // },
            // 获取检测链接m
            getMonitoringLink() {
                monitoringLink({
                    appid: localStorage.getItem('appId'),
                }).then(response => {
                    if (response.data.head.flag === 0) {
                        let oInput = document.createElement('input')
                        oInput.value = response.data.content.monitoringLink
                        document.body.appendChild(oInput)
                        oInput.select() // 选择对象
                        document.execCommand("Copy") // 执行浏览器复制命令
                        this.$message({
                            message: '复制成功',
                            type: 'success'
                        })
                        oInput.remove()
                    } else {
                        this.$message.error(response.data.head.desc);
                    }
                })
            },
            // 复制渠道
            handleCopy (url) {
                let oInput = document.createElement('input')
                oInput.value = url
                document.body.appendChild(oInput)
                oInput.select() // 选择对象
                document.execCommand("Copy") // 执行浏览器复制命令
                this.$message({
                    message: '复制成功',
                    type: 'success'
                })
                oInput.remove()
            },
        }
    }
</script>
